import { Column } from "primereact/column";
import { TreeTable } from "primereact/treetable";
import React, { Suspense, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { getTimeSheet, getTimeSheetStatus, postTimeSheet, postTimeStatusUpdate } from "./TimeSheetServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import dayjs from "dayjs";
import { event } from "jquery";
import { getRawSystemAlertsArray } from "../../../Routes/AuthGard/usePermissions";




const TimesheetApproval = () => {
  const [Isloading, setIsloading] = useState(false);
  const getMonday = (date) => {
    const d = dayjs(date);
    const day = d.day();
    return d.subtract(day === 0 ? 6 : day - 1, "day");
  };
  const [currentStart, setCurrentStart] = useState(() => getMonday(dayjs()));
  // const [currentStart, setCurrentStart] = useState(dayjs().subtract(7, "day"));
  const toster = useContext(TostMsg);
  let SystemAlerts = getRawSystemAlertsArray();
  const [filterGroupBy, setFilterGroupBy] = useState({ text: 'By Project & Tasks', value: 3 });
  const startDate = currentStart.format("DD MMM YYYY");
  const endDate = currentStart.add(6, "day").format("DD MMM YYYY");
  const [timesheetList, setTimesheetList] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [selectedNodeKeys, setSelectedNodeKeys] = useState({});
  const [weekDates, setWeekDates] = useState([]);






  useEffect(() => {
    const start = getMonday(currentStart);
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = start.add(i, "day");
      dates.push({ label: date.format("dd, DD MMM"), iso: date.format("YYYY-MM-DD") });
    }
    setWeekDates(dates);
  }, [currentStart]);

  useEffect(() => {
    GetTimeSheet(filterGroupBy?.type2);
  }, [currentStart]);

  async function GetTimeSheet(GroupBy) {
    setIsloading(true);
    const body = {
      EmpId: 0,//userDetails?.EmpId,
      ClientId: 0,
      ProjectId: 0,
      StatusId: 0,
      GroupBy: GroupBy || 3,
      HierarchyTypeId: 3,
      FetchType: 1,
      BillableType: 0,
      StartDate: String(startDate),
      EndDate: String(endDate),
    };

    try {
      const response = await getTimeSheet(body);
      const apiData = response?.Data;
      if (!apiData?.TimeSheetResponses?.length) {
        setTimesheetList([]);
        return;
      }
      const nodes = apiData.TimeSheetResponses.map((group, index) => {
        const groupKey = `${index + 1}`;

        const totalBillable = group.BillableHours ?? 0;
        const submittedHours = group.Hours ?? 0;

        return {
          key: groupKey,
          data: {
            id: group.Id,
            user: group.GroupByName,
            byDate: "",
            billableHours: totalBillable.toFixed(2),
            submittedHours: submittedHours.toFixed(2),
            pending: group.PendingHours?.toFixed(2) ?? "0.00",
            approved: group.ApprovedHours?.toFixed(2) ?? "0.00",
            rejected: group.RejectedHours?.toFixed(2) ?? "0.00",
            //  status: group.StatusName ?? 'N/A',
          },
          children: group.TimeSheets.map((t, tIndex) => ({
            key: `${groupKey}-${tIndex + 1}`,
            data: {
              id: t.Id,
              statusId: t.TimeSheetStatusId ?? t.StatusId ?? 0,
              ProjectName: t?.ProjectName,
              user: t.Task,
              byDate: new Date(t.TimeSheetDate).toLocaleDateString(),
              billableHours: t.BillableHours?.toFixed(2),
              submittedHours: t.Hours?.toFixed(2),
              pending: t.PendingHours ?? 0,
              approved: t.ApprovedHours ?? 0,
              rejected: t.RejectedHours ?? 0,
              status: t.StatusName ?? 'N/A',
            },
          }))
        };
      });

      setTimesheetList(nodes);

    } catch (err) {
      toster.current.error("Failed to load timesheet");
    } finally {
      setIsloading(false);
    }
  }
  const hasSelection = useMemo(() => Object.keys(selectedNodeKeys).length > 0, [selectedNodeKeys]);
  const getSelectedTimesheetIds = () => {
    const ids = [];
    timesheetList.forEach((parent) => {
      if (parent.children) {
        parent.children.forEach((child) => {
          if (selectedNodeKeys[child.key]) {
            ids.push(child.data.id);
          }
        });
      }
    });
    return ids;
  };

  const findNodeByKey = (key, nodes = timesheetList) => {
    for (const node of nodes) {
      if (String(node.key) === String(key)) return node;
      if (node.children) {
        const child = findNodeByKey(key, node.children);
        if (child) return child;
      }
    }
    return null;
  };

  const isRowSelectable = (node) => {
    if (!node || !node.data) {
      return false;
    }

    const statusId = Number(node.data?.statusId ?? node.data?.TimeSheetStatusId ?? node.data?.StatusId ?? 0);
    const statusText = String(node.data?.status || "").toLowerCase();
    const isRejectedOrApproved = statusId === 103 || statusId === 104 || statusText === "approved" || statusText === "rejected";
    return !isRejectedOrApproved;
  };

  const filterSelectionKeys = (selectionKeys) => {
    if (!selectionKeys || typeof selectionKeys !== "object") return {};
    return Object.keys(selectionKeys).reduce((acc, key) => {
      const node = findNodeByKey(key);
      if (node && isRowSelectable(node)) {
        acc[key] = selectionKeys[key];
      }
      return acc;
    }, {});
  };

  const handleSelectionChange = (e) => {
    setSelectedNodeKeys(filterSelectionKeys(e.value));
  };

  const GetMasterSystemAlertList = useCallback((message, type) => {
    SystemAlerts?.forEach((msg) => {
      if (msg?.Name === message && type === 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);


  const TimeSheetValidation = Yup.object().shape({
    TimeSheetDate: Yup.string().required("Time sheet date is required."),
    ProjectId: Yup.string().required("Project is required."),
  });

  const handlePrevWeek = () => {
    setCurrentStart((prev) => prev.subtract(7, "day"));
  };

  const handleNextWeek = () => {
    setCurrentStart((prev) => prev.add(7, "day"));
  };

  const userFilterChange = (event) => {
    let type = event.target.value
    GetTimeSheet(type);
    if (type == 3) {
      setFilterGroupBy({ text: 'By Project & Tasks', value: 3 })
    } else if (type == 2) {
      setFilterGroupBy({ text: 'By Date & Tasks', value: 2 })
    } else {
      setFilterGroupBy({ text: 'By User & Tasks', value: 1 })
    }
  }
  const ChangeStatus = async (rowData, statusId) => {
    const timesheetId = rowData.data.id;
    await bulkStatusUpdate([timesheetId], statusId);
  };

  const bulkStatusUpdate = async (ids, statusId) => {
    if (!ids || ids.length === 0) return;

    setIsloading(true);
    const xmlPayload = `<root>${ids.map(id => `<TimeSheet><Id>${id}</Id></TimeSheet>`).join("")}</root>`;

    const params = {
      TimeSheetId: xmlPayload,
      StatusId: statusId
    };

    try {
      await postTimeStatusUpdate(params);
      toster.current.success(
        statusId === 103
          ? `${ids.length} timesheet(s) approved successfully`
          : `${ids.length} timesheet(s) rejected successfully`
      );
      GetTimeSheet(filterGroupBy?.type2);
      setSelectedNodeKeys({}); // Clear selection
    } catch (error) {
      toster.current.error("Failed to update status");
    } finally {
      setIsloading(false);
    }
  };

  const rowClassName = (node) => {
    const statusId = Number(node?.data?.statusId ?? node?.data?.TimeSheetStatusId ?? node?.data?.StatusId ?? 0);

    if (statusId === 103) return 'row-status-103';
    if (statusId === 104) return 'row-status-104';

    if (node.data?.status === "Approved") return 'row-approved';
    if (node.data?.status === "Rejected") return 'row-rejected';

    const hasApprovedChild = node.children?.some(child => child.data?.status === "Approved" || Number(child.data?.statusId) === 103);
    const hasRejectedChild = node.children?.some(child => child.data?.status === "Rejected" || Number(child.data?.statusId) === 104);

    if (hasApprovedChild) return 'row-approved';
    if (hasRejectedChild) return 'row-rejected';

    return ''; // default
  };



  return (
    <div>
      <div className="container-fluid   position-relative">
        <div className="row team-directories g-3">
          <div className="col-xl-12">
            <div className="form-head ">
              <div className="">
                <h2 className="font-w600 mb-0">Timesheet Approval  </h2>
                <p>Manage your tasks, projects, and workspaces in one place.</p>
                <div className="d-flex align-items-center justify-content-between timesheet-range">
                  <div className=" d-flex align-items-center">
                    <div className="timeclick-box me-2 week-nav">

                      <button className="btn btn-default nav-btn" onClick={handlePrevWeek}>←</button>
                      <span className="week-range">
                        {startDate} — {endDate}
                      </span>
                      <button className="btn btn-default nav-btn" onClick={handleNextWeek}>→</button>


                    </div>
                    <div className="timebox-edit-column  d-flex align-items-center">
                      <i className="fa fa-users text-dark" aria-hidden="true"></i>
                      <select className="form-select" aria-label="Default select example" onChange={(event) => userFilterChange(event)}>
                        <option value={1}>By User & Tasks</option>
                        <option value={2}>By Date & Tasks</option>
                        <option selected value={3}>By Project & Tasks</option>

                      </select>
                    </div>
                  </div>

                  <div className="rightside-tabs" >
                    <Link to="/Timesheet/Entry">
                      <button className="btn-og btn-og-secondary btn-og-sm ">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-arrow-left-short"
                          viewBox="0 0
                     16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12 8a.5.5 0 0 1-.5.5H5.7
                     07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
                     .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                          ></path>
                        </svg>{" "}
                        Back
                      </button>
                    </Link>

                  </div>

                </div>
              </div>

            </div>
          </div>

          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="timesheet-area">
                    <div className=" bg-transparent">
                      <div className="card-body p-0">
                        <div className="setting-detail-list">
                          <div className="detail award-detail">
                            <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
                            <div className="col-md-12 column border-0">
                              {hasSelection && (
                                <div className="alert alert-light border shadow-sm mb-3 d-flex align-items-center gap-3 animate__animated animate__fadeIn">
                                  <strong>{Object.keys(selectedNodeKeys).length} selected</strong>

                                  <button
                                    className="btn btn-success d-flex align-items-center gap-2"
                                    onClick={() => bulkStatusUpdate(getSelectedTimesheetIds(), 103)}
                                  >
                                    <i className="bi bi-check-all fs-5"></i>
                                    Bulk Approve Selected
                                  </button>

                                  <button
                                    className="btn btn-danger d-flex align-items-center gap-2"
                                    onClick={() => bulkStatusUpdate(getSelectedTimesheetIds(), 104)}
                                  >
                                    <i className="bi bi-x-circle-fill fs-5"></i>
                                    Bulk Reject Selected
                                  </button>

                                  <button
                                    className="btn btn-outline-secondary ms-auto"
                                    onClick={() => setSelectedNodeKeys({})}
                                  >
                                    Clear Selection
                                  </button>
                                </div>
                              )}
                              <div className="table-responsive dtbl">
                                <TreeTable
                                  value={timesheetList}
                                  rowClassName={rowClassName}
                                  tableStyle={{ minWidth: "60rem" }}
                                  selectionMode="checkbox"
                                  selectionKeys={selectedNodeKeys}
                                  onSelectionChange={handleSelectionChange}
                                  rowSelectable={isRowSelectable}
                                  className="table table-bordered table-hover treeapproval-table"
                                >
                                  {/* <Column field="user" header={filterGroupBy?.text} expander  /> */}
                                  <Column className="timetable-name-bx"
                                   
                                    field="user"
                                    header={filterGroupBy?.text}
                                    expander
                                    body={
                                      filterGroupBy?.value !== 3
                                        ? (rowData) => {
                                          const isChild = !rowData.children;

                                          return (
                                            <div>
                                              <div>{rowData.data.user}</div>

                                              {isChild && rowData.data.ProjectName && (
                                                <small
                                                  style={{
                                                    background: "#e9d8fd",
                                                    color: "#6b21a8",
                                                    padding: "2px 8px",
                                                    borderRadius: "6px",
                                                    fontWeight: "600",
                                                    display: "inline-block",
                                                    marginTop: "2px",
                                                  }}
                                                >
                                                  {rowData.data.ProjectName}
                                                </small>
                                              )}
                                            </div>
                                          );
                                        }
                                        : undefined}
                                  />
                                  <Column field="submittedHours" header=" Submitted Hours" />
                                  <Column field="billableHours" header="Billable Hours" />
                                  <Column field="pending" header="Pending Hours" />
                                  <Column field="rejected" header="	Rejected Hours" />
                                  <Column field="approved" header="Approved Hours" />
                                  <Column field="status" header="Status" />
                                  <Column
                                    header="Action"
                                    body={(rowData) => {
                                      const isExpandable = !!rowData.children; // row has expander icon

                                      return (
                                        <div className="flex flex-wrap gap-2">
                                          {!isExpandable && (
                                            <>
                                              <button className="btn btn-purple me-2" onClick={() => ChangeStatus(rowData, 103)}>
                                                <i className="fa fa-thumbs-up"></i>
                                              </button>

                                              <button className="btn btn-danger" onClick={() => ChangeStatus(rowData, 104)}>
                                                <i className="fa fa-thumbs-down"></i>
                                              </button>
                                            </>
                                          )}
                                        </div>
                                      );
                                    }}
                                  />
                                </TreeTable>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : null}
    </div>
  )

}
export default TimesheetApproval;